import React from 'react';
import { useSelector } from 'react-redux';
import useNotifications from '../hooks/useNotifications';

const NotificationManager = () => {
  const { token } = useSelector(state => state.auth);

  // Get userId from token or localStorage - need to decode token to get userId
  const getUserId = () => {
    if (token) {
      try {
        // Decode JWT token to get userId
        const payload = JSON.parse(atob(token.split('.')[1]));
        const userId = payload.userId || payload.id || payload.sub;
        return userId;
      } catch (error) {
        console.error('NotificationManager: Error decoding token:', error);
      }
    }
    const localUserId = localStorage.getItem('userId');
    return localUserId;
  };
  
  const userId = getUserId();
  
  // Initialize global notifications - this will persist across page navigation
  // The hook itself will check if SSE is enabled and return early if disabled
  useNotifications(userId);

  // This component doesn't render anything, it just manages the connection
  return null;
};

export default NotificationManager;
